"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRange = exports.getEnumKey = exports.randomEnumValue = exports.generateUUID = exports.getRandomString = exports.getRandomArbitrary = exports.getRandomItemFromArray = exports.getRandomInt = void 0;
const getRandomInt = (min = 0, max = 100) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
};
exports.getRandomInt = getRandomInt;
const getRandomItemFromArray = (items) => items[Math.floor(Math.random() * items.length)];
exports.getRandomItemFromArray = getRandomItemFromArray;
const getRandomArbitrary = (min, max) => Math.random() * (max - min) + min;
exports.getRandomArbitrary = getRandomArbitrary;
const getRandomString = (idLength = 6) => {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < idLength; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
};
exports.getRandomString = getRandomString;
const generateUUID = () => {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        // tslint:disable-next-line:no-bitwise
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        // tslint:disable-next-line:no-bitwise
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
};
exports.generateUUID = generateUUID;
const randomEnumValue = (enumeration) => {
    const values = Object.keys(enumeration);
    const enumKey = values[Math.floor(Math.random() * values.length)];
    return enumeration[enumKey];
};
exports.randomEnumValue = randomEnumValue;
const getEnumKey = (value, enumType) => {
    return Object.keys(enumType).find((val) => enumType[val] === value);
};
exports.getEnumKey = getEnumKey;
const getRange = (itemCount) => [...Array(itemCount).keys()];
exports.getRange = getRange;
//# sourceMappingURL=helper-functions.js.map